<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('clients.clients') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewClient'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('clients.client') }}
      </v-btn>
    </v-row>
    <!-- <base-page-title title="Cadastro de Cliente">
      <template v-slot:actions>
        <f-btn alt_label="Cadastrar de Cliente" alt_icon="mdi-plus"></f-btn>
      </template>
    </base-page-title> -->
    <client-list class="mt-5"></client-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'ClientListPage',
  components: {
    ClientList: () => import('@/components/client/ClientList.vue'),
  },
}
</script>

<style scoped>

</style>